<template>
  <div class="d-flex justify-content-between flex-wrap">
    <template v-for="planFood in planFoods">
      <b-card
        :title="planFood.Title"
        bg-variant="light"
        style="width:49%;"
      >
        <b-card-body>
          <div
            style="width:100%;overflow-x: auto;"
            class="c-scroll"
          >
            <div
              class="d-flex"
              style="width:fit-content"
            >
              <template v-for="food in planFood.Food">
                <b-card
                  border-variant="info"
                  style="width:120px;padding:10px"
                  no-body
                  class="mr-1 text-center card-meal mt-auto"
                >
                  <strong class="text-bold">
                    {{ food.Title }}
                  </strong>
                  <div>
                    <hr>
                  </div>
                  <p class="mb-1 bg-light-info">
                    {{ food.Consumption }}
                  </p>
                  <div class="d-flex justify-content-between">
                    <div class="text-center">
                      <p> {{ food.Calorie }} </p>
                      <p class="text-center">
                        کالری
                      </p>
                    </div>
                    <div class="text-center">
                      <p>{{ food.Gram }}</p>
                      <p>گرم </p>
                    </div>
                  </div>
                </b-card>
              </template>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </template>
  </div>
</template>
<script>
export default {
  name: 'FoodSchedule',
  props: {
    dietInDate: { type: String, default: '' },
    userId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      planFoods: [],
      message: null,
    }
  },
  watch: {
    dietInDate() {
      this.userPlanFood()
    },
  },
  created() {
    this.userPlanFood()
  },
  methods: {
    userPlanFood() {
      this.$http.post(this.$api.userPlanFood.get, {
        FromDate: this.dietInDate,
        ToDate: this.dietInDate,
        UserId: this.userId,
      }).then(res => {
        if (res.data.length){
          this.planFoods = res.data[0].FoodMeal
        }
      })
    },
  },
}
</script>
  <style scoped lang="scss">
    .card-meal{
    p{
    padding:0;
    margin:0;
    }
    }
  </style>
